import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { NOTIFICATION_TYPE } from "../enums/notification.type";
import { Notification } from "../models/notification.model";

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    notifications: Observable<Notification>;
    private _notifications = new Subject<Notification>();

    constructor() {
        this.notifications = this._notifications.asObservable();
    }

    /**
   * Show success toast notification.
   * @param title Toast title
   * @param message Toast message
   */
  showSuccessNotify(title: string, message: string) {
    this._notifications.next({
      message,
      title,
      type: NOTIFICATION_TYPE.Success,
    });
  }

  /**
   * Show info toast notification.
   * @param title Toast title
   * @param message Toast message
   */
  showInfoNotify(title: string, message: string) {
    this._notifications.next({
      message,
      title,
      type: NOTIFICATION_TYPE.Info,
    });
  }

  /**
   * Show warning toast notification.
   * @param title Toast title
   * @param message Toast message
   */
  showWarningNotify(title: string, message: string) {
    this._notifications.next({
      message,
      title,
      type: NOTIFICATION_TYPE.Warning,
    });
  }

  /**
   * Show error toast notification.
   * @param title Toast title
   * @param message Toast message
   */
  showErrorNotify(title: string, message: string) {
    this._notifications.next({
      message,
      title,
      type: NOTIFICATION_TYPE.Error,
    });
  }
}